import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as AppMapping from '@services/store/actions/app'

export const useAppDrawer = () => {
    const store = useStore()
    const app = bindActionCreators(AppMapping, store.dispatch)
    const appStore = useSelector(state => state.app.drawer)

    const show = () => {
        app.showDrawer()
    }

    const hide = () => {
        app.hideDrawer()
    }

    const showLeftPanel = () => {
        app.showLeftPanel()
    }

    const hideLeftPanel = () => {
        app.hideLeftPanel()
    }

    return {
        show, hide, config: appStore,
        showLeftPanel, hideLeftPanel
    }
}